import React, { useEffect, useMemo, useState } from 'react';
import { Balloon, Button, Form, Input, Overlay, Tag, Tab, Loading } from '@alifd/next';
import { history } from 'ice';
import LzMsg from '@/components/common/LzMessage';
import styles from './index.module.scss';
import { Servlets } from '@/service';
import moment from 'moment';
import TagMapping from './components/TagMapping';
import TagMappingData from './components/Nodes/validators';
import utils from '@/common/utils';

// 根据后端返回的type确定不同类型的标签展示，1.单选 2.多选 5.区间值 6.时间区间  9.自定义(sku) 10.单选里再多一层级(例:近期在直播间下单sku:直播间类型)
const tagArr = ['TagRadio', 'TagCheckbox', 'TagProvince', 'TagSlider', 'TagSection', 'TagTime', 'TagCategories', 'TagCrowd', 'TagSku', 'TagRadioDouble'];
const CrowdTagYunLu = ({ match }) => {
  // 格式化默认人群名称里的时间
  const formatDateFun = (value) => {
    const date = new Date(value);
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? (`0${MM}`) : MM;
    let d = date.getDate();
    d = d < 10 ? (`0${d}`) : d;
    let h = date.getHours();
    h = h < 10 ? (`0${h}`) : h;
    let m = date.getMinutes();
    m = m < 10 ? (`0${m}`) : m;
    let s = date.getSeconds();
    s = s < 10 ? (`0${s}`) : s;
    return `默认创建${MM}月${d}日${h}时${m}分${s}秒`;
  };
  // 生成人群所需填写的人群信息
  const [crowdInfo, setCrowdInfo] = useState({
    name: formatDateFun(new Date()),
    description: moment().format('YYYY MM月DD日创建人群').toString().split(' ')[1],
  });
  // 人群预估出的人数
  const [crowdNum, setCrowdNum] = useState(0);

  // 人群标签，左侧渲染的所有标签
  const [tagList, setTagList] = useState([]);
  // 选中标签生成的结构，即右侧展示的内容
  const [activeTagList, setActiveTagList] = useState([]);
  // 处理完成后的中间taglist的副本（便于点击左边tag更换中间内容）
  const [tempTagList, setTempTagList] = useState([]);
  // 是否已进行人群预估
  const [estimateStatus, setEstimateStatus] = useState(false);
  // 是否创建成功
  const [createSucc, setCreateSucc] = useState(false);
  // 当前所选中的总分类label
  const [currentKey, setCurrentKey] = useState(0);
  // 最左边的总分类标签
  const [leftGroupList, setLeftGroupList] = useState([]);
  // 中间的分类标签
  const [middleGroupList, setMiddleGroupList] = useState([]);
  // 接口请求时间较长，需要加loading
  const [isLoading, setIsLoading] = useState(true);

  /**
   * 人群预估
   */
  const estimateFun = async () => {
    try {
      const bodyParam = await checkFun();
      Servlets('yunLuCrowdEstimate', bodyParam).then((res) => {
        if (res.success) {
          setCrowdNum(res.data);
          setEstimateStatus(true);
          LzMsg.success('预估成功', '');
          setIsLoading(false);
        } else {
          LzMsg.error(res.resp_msg);
          setIsLoading(false);
        }
      });
    } catch (e) {
      LzMsg.error(e.message, '');
      setIsLoading(false);
    }
  };

  /**
   * 人群创建
   */
  const createFun = async () => {   
    try {
      const bodyParam = await checkFun();
      Servlets('saveYunLuCrowd', bodyParam).then((res) => {
        if (res.success) {
          setTimeout(() => {
            history.push('/CustomerManagement');
          }, 3000);
          setIsLoading(false);
          setCreateSucc(true);
        } else {
          LzMsg.error(res.resp_msg);
          setIsLoading(false);
        }
      });
    } catch (e) {
      LzMsg.error(e.message);
      setIsLoading(false);
    }
  };

  /**
   * 校验
   */
 const checkTagData = async (currentTagType, currentTagInfo) => {
  return TagMappingData.validators[currentTagType]({...currentTagInfo})
 }

  /**
   * 进行人群预估和保存之前的校验方法
   */
  const checkFun = async () => {
    setIsLoading(true);
    const arr = [...activeTagList];
    if (!activeTagList.length) {
      throw new Error('请先选择标签');
    }
    if (crowdInfo.name) {
      const bodyParam = { // 先写出一个基本结构体
        peopleName: crowdInfo.name,
        peopleDescription: crowdInfo.description,
        mergeType: 0, // 合并类型 0-交 1-并 2-差
        tabList:[]
      };
      try {
        for ( let contItem of arr) {
          for (let item of contItem.crowdLabels) {
            for (let subItem of item.crowdLabels) {
              const tabObj = {
                tabId:subItem.id,
                tabName:subItem.labelName,
                peopleList:[],
              }
              bodyParam.tabList.push(tabObj);
              for (let infoItem of subItem.crowdLabels) {
                await checkTagData(tagArr[+infoItem.labelType - 1],infoItem);
                const obj = {
                  labelName: infoItem.labelName,
                  labelType: infoItem.labelType,
                  labelDescription: infoItem.labelDescription,
                  opType: infoItem.opType,
                  opValue: infoItem.opValue,
                  labelId:infoItem.id
                };
                bodyParam.tabList.forEach((tabItem)=>{
                  if(tabItem.tabId === infoItem.id.slice(0,tabItem.tabId.length)) {
                    tabItem.peopleList.push(obj)
                  }    
                })
              }
            }
          }
        }
        return bodyParam;
      } catch (e) {
        throw e;
      }
    } else if (!crowdInfo.name) {
      throw new Error('人群名称不能为空');
    }
    // else if (!crowdInfo.description) {
    //   throw new Error('人群描述不能为空');
    // }
  };

  /**
   * @description: 创建时点击选择一个标签，或者复制时反显所选标签
   * @param {*} activeTagArr 右侧选中数组的一个深拷贝结果，改变这个数组，最后赋值给右侧选中数组
   * @param {*} contItem 一维数据
   * @param {*} contIndex 一维索引
   * @param {*} item 二维数据
   * @param {*} index 二维索引
   * @param {*} subItem 三维数据
   * @param {*} subIndex 三维索引
   * @return {*} activeTagArr 是处理好的右侧选中内容
   */
  const changeTagTrue = (activeTagArr, contItem, contIndex, item, index, subItem, subIndex) => {
    const tip1 = activeTagArr.findIndex((value) => value.labelDescription === contItem.labelDescription); // 判断这条数据的类型是否存在右侧渲染数组里，其一维索引是几
    let tip2 = -1;
    if (tip1 != -1) {
      tip2 = activeTagArr[tip1].crowdLabels.findIndex((value) => value.labelDescription === item.labelDescription); // 其二维索引是几
    }
    if (tip1 !== -1) { // 如果这条数据在右侧渲染数组里，直接放进这个类型下面
      if (tip2 != -1) { // 如果有相同的二级分类，放进去，没有就直接push一个
        activeTagArr[tip1].crowdLabels[tip2].crowdLabels.push(subItem);
      } else {
        activeTagArr[tip1].crowdLabels.push({
          tempIndex: index,
          labelDescription: item.labelDescription,
          crowdLabels: [
            {
              ...subItem,
              tempIndex: subIndex,
            },
          ],
        });
      }
    } else { // 如果没有需要新加出来一个类型
      activeTagArr.push({
        tempIndex: contIndex, // 为了方便删除时在中间列数组中找到对应索引，每次push时加一个index进去
        labelDescription: contItem.labelDescription,
        crowdLabels: [{
          tempIndex: index, // 索引同理
          labelDescription: item.labelDescription,
          crowdLabels: [
            {
              ...subItem,
              tempIndex: subIndex, // 索引同理
            },
          ],
        }],
      });
    }
    return activeTagArr;
  };

  /**
   * @description: 点击左侧标签新增一条右侧对应选框内容
   * @param {*} contItem 一维的数组内容
   * @param {*} contIndex 一维索引
   * @param {*} item 二维的数组内容
   * @param {*} index 二维索引
   * @param {*} subItem 三维的数组内容
   * @param {*} subIndex 三维索引
   * @param {*} source 操作来源，isMiddleClick-证明是点击中间数组（这个是为了在取消选中时，针对数组索引不同处理）
   * @return {*}
   */
  const createTag = (contItem, contIndex, item, index, subItem, subIndex, source = '') => {
    // 每次获取最新的中间和右侧渲染数组，处理这个变量，最后再赋值回去
    let activeTagArr = JSON.parse(JSON.stringify(activeTagList));
    const tagArr = JSON.parse(JSON.stringify(tempTagList));
    if (subItem.status) { // 如果已选，取消选择，右侧渲染数组中删除这条数据
      tagArr[contItem.tempIndex].crowdLabels[item.tempIndex].crowdLabels[subItem.tempIndex].status = false; // 改变中间渲染数据的选中状态
      tagArr[contItem.tempIndex].crowdLabels[item.tempIndex].crowdLabels[subItem.tempIndex].crowdLabels.forEach((infoItem,infoIndex)=>{
        infoItem.opValue = null;
        infoItem.opType = ''
      })
      // 针对点击右侧的组件或者中间展示数组进行取消，索引是不同的
      const tip1 = source === 'isMiddleClick' ? activeTagArr.findIndex((item) => item.tempIndex === contIndex) : contIndex;
      const tip2 = source === 'isMiddleClick' ? activeTagArr[tip1].crowdLabels.findIndex((item) => item.tempIndex === index) : index;
      const tip3 = source === 'isMiddleClick' ? activeTagArr[tip1].crowdLabels[tip2].crowdLabels.findIndex((item) => item.tempIndex === subIndex) : subIndex;
      activeTagArr[tip1].crowdLabels[tip2].crowdLabels.splice(tip3, 1); // 把右侧选中的组件删掉

      if (activeTagArr[tip1].crowdLabels[tip2].crowdLabels.length === 0) {
        activeTagArr[tip1].crowdLabels.splice(tip2, 1); // 如果二级分类的内容都删掉了，就把这个二级分类也删掉
      }
      if (activeTagArr[tip1].crowdLabels.length === 0) {
        activeTagArr.splice(tip1, 1); // 如果一级分类的内容都删掉了，就把这个一级分类也删掉
      }
    } else { // 未选就添加进去
      if (getActiveListNum >= 10) {
        LzMsg.error('所选标签数不能超过10个');
        return;
      }
      const pushIndex = currentKey;

      // 改变中间缓存渲染数据的选中状态，为方便后续的取消选中，给每一分类加上tempIndex
      tagArr[pushIndex] = {
        ...tagArr[pushIndex],
        tempIndex: contIndex,
      };
      tagArr[pushIndex].crowdLabels[index] = {
        ...tagArr[pushIndex].crowdLabels[index],
        tempIndex: index,
      };
      tagArr[pushIndex].crowdLabels[index].crowdLabels[subIndex] = {
        ...tagArr[pushIndex].crowdLabels[index].crowdLabels[subIndex],
        tempIndex: subIndex,
        status: true,
      };

      // 为右侧渲染的数组准备数据
      subItem.opType = ''; // 本个标签的操作符类型，区间、大于、小于等等，参考同级文件tagSaveDemo.json
      subItem.opValue = null; // 这个标签选的值
      subItem.status = true; // 选中状态，置为true
      subItem.tempIndex = subIndex; // 加一个针对于整个大数组的索引，方便后续的删除
      activeTagArr = changeTagTrue(activeTagArr, contItem, contIndex, item, index, subItem, subIndex);
    }
    setTempTagList(tagArr); // 把暂存区数据的是否选中状态更新
    setMiddleGroupList([tagArr[currentKey]]); // 改变中间数组的状态，如果不是0，就要在tagArr里取出对应的那一组分类，并把它变成一个数组的形式
    setActiveTagList(activeTagArr);
  };

  /**
   * @description: 改变activeTagList每条数据的selectedValue选中值
   * @param {*} contIndex 一级索引
   * @param {*} index 二级索引
   * @param {*} subIndex 三级索引
   * @param {*} newData 最新改变的那个值
   * @return {*}
   */
  const changeActiveTagValue = (contIndex, index, subIndex, infoIndex, newData) => {
    const arrVal = [...activeTagList];
    Object.assign(arrVal[contIndex].crowdLabels[index].crowdLabels[subIndex].crowdLabels[infoIndex], newData);
    setActiveTagList(arrVal);
  };

  // 中间结构
  const returnHtml = (contItem, contIndex) => {
    return (<div key={`middle_group_${contIndex}`} className={`${styles['label-kind']} main-tag`}>
      {
        contItem.crowdLabels.map((item, index) => {
          return (<div key={`middle_group_one_${index}`}>
            <div className={`${styles['second-title']}`}>{item.labelDescription}</div>
            {/* 二级分类名 */}
            {
              item.crowdLabels.map((subItem, subIndex) => {
                return (
                  <Balloon.Tooltip
                    popupContainer={(target) => target.parentNode}
                    align="t"
                    key={`middle_group_two_${subIndex}`}
                    trigger={<Tag.Selectable
                      key={`middle_group_two2_${subIndex}`}
                      checked={subItem.status}
                      onChange={() => createTag(contItem, contIndex, item, index, subItem, subIndex, 'isMiddleClick')}
                      style={{
                        width: '45%',
                        marginLeft: '2.5%',
                        marginTop: '2%',
                      }}
                      className={styles.pointer}
                    >
                      {subItem.labelName} {/* 标签名 */}
                    </Tag.Selectable>}
                  >
                    {subItem.labelName}：{subItem.labelDescription}
                  </Balloon.Tooltip>
                );
              })
            }
          </div>);
        })
      }
    </div>);
  };
  /**
   * @description: 标签复制
   * @param {*} data 接口查询回来的所有标签
   * @return {*}
   */
  const copyTag = (data) => {
    try {
      const esJson = JSON.parse(sessionStorage.getItem('YunLuCrowdEsJson')); // 在缓存中取出策略信息
      const obj = {
        name: `${esJson.name}副本` ?? '复制人群策略副本',
        description: esJson.labelDescription ?? crowdInfo.description,
      };
      if (obj.name.length >= 32) { // 如果复制过来，名字过长，就强行处理一下
        obj.name = '复制人群策略副本';
      }
      // 给人群名称和描述赋值
      setCrowdInfo({
        ...crowdInfo,
        ...obj,
      });

      // 返显选中标签
      let activeTagArr = JSON.parse(JSON.stringify(activeTagList)); // 深拷贝一个右侧已选数组，准备改变它的值
      data?.forEach((contItem, contIndex) => {
        contItem?.crowdLabels.forEach((item, index) => { //item：活动标签或交易标签层
          item?.crowdLabels.forEach((subItem, subIndex) => {//subItem :近期参加优惠活动人群层
            // 判断要复制的人群策略里有没有这个标签
            esJson?.list.forEach((esItem, esIndex) => { //esItem :近期参加优惠活动人群层
              if (esItem.tabName === subItem.labelName) {

                /** 开始 */
                // 给中间数组赋值，需要把用到的索引和标签状态改好
                subItem.crowdLabels.forEach((infoItem,infoIndex)=>{
                  infoItem.opValue = esItem.peopleList[infoIndex].opValue
                  infoItem.opType = esItem.peopleList[infoIndex].opType
                })
                subItem = {
                  ...subItem,
                  status: true,
                  tempIndex: subIndex,
                  // ...esItem,
                  // crowdLabels:[...esItem.peopleList],
                };
                item.crowdLabels[subIndex] = subItem;
                item = {
                  ...item,
                  tempIndex: index,
                };
                data[contIndex].crowdLabels[index] = item;
                data[contIndex] = {
                  ...data[contIndex],
                  tempIndex: contIndex,
                };
                /** 结束 */
                // changeTagTrue(activeTagArr, contItem, contIndex, item, index, subItem, subIndex);
                activeTagArr = changeTagTrue(activeTagArr, contItem, contIndex, item, index, subItem, subIndex); // 改变右侧选中的数组，往里加一条标签
              }
            });
            // })
          });
        });
      });

      setLeftGroupList([...data]); // 给左侧标签组赋值
      setTempTagList(data); // 确认中间暂存区所有数据
      setMiddleGroupList(data); // 给中间展示的数组赋值
      setActiveTagList(activeTagArr); // 给右侧数组赋值
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      LzMsg.error(e.message);
    }
  };

  /** 设置 Header 面包屑 */
  const setBreadcrumb = () => {
    /** 设置Header面包屑 */
    utils.setBreadcrumb({
      name: '客户管理', // 一级页面名称
      url: '/web/CustomerManagement', // 一级页面url
      children: {
        name: '人群管理', // 二级页面名称
        url: '/web/CustomerManagement', // 二级页面url
        children: {
          name: '标签组合', // 三级页面名称
          url: '', // 三级页面url
        },
      },
    });
  };

  // 获取所有标签
  const getTags = async () => {
    await Servlets('getYunLuTag', {}).then((res) => {
      if (res.success) {
        const data = res.data.tab_list;
      data.forEach(i1 => {
          i1.labelName = i1?.tab_name; // 活动标签
          i1.labelDescription = i1?.tab_name;
            i1.crowdLabels = i1?.sub_tab?.map(i2 => {
              return {
                labelName: i2?.tab_name, // 活动标签 == 活动标签
                labelDescription: i2?.tab_name,
                crowdLabels: i2?.sub_label_tab?.map(i3 => {
                  return {
                    id:i3?.tab_id,
                    labelName: i3?.tab_name, // 活动标签 == 近期参加优惠活动人群
                    labelDescription: i3?.tab_desc,
                    crowdLabels: i3?.label_list?.map(i4 => {
                      return { // 老客维度
                        id: i4?.label_id,
                        labelName: i4?.label_name, // 
                        labelDescription: i4?.label_desc,
                        label_desc: i4?.label_desc,
                        labelType: i4?.label_type,
                        valueType: i4?.label_type,
                        value: i4?.param_list?.map(i5 => {
                          return {
                            realValue: i5?.param_id,
                            fieldValue: i5?.param_name,
                            ...i5,
                            param_list:i5?.param_list?.map(i6 => {
                              return {
                                realValue: i6?.param_id,
                                fieldValue: i6?.param_name,
                                ...i6,
                              }
                            }),
                          }
                        })
                      }
                    })
                  }
                })
              }
            });
        });
        if (match.params.type === 'create') {
          setLeftGroupList([
            ...data
          ]);
          setMiddleGroupList(data); // 给初始中间分组的list赋值
          setTempTagList(data); // 把所有分类存起来，这样可以每次点击时直接取这个暂存区的值
          setIsLoading(false);
        } else {
          copyTag(data);
        }
        setTagList(data); // 目前有两种情况，白名单商家具有品类标签，所以返回数据是多条，前端把所有数据暂存一次，方便以后切换用
      } else {
        setIsLoading(false);
        LzMsg.error(res.resp_msg);
      }
    });
  };
  /**
   * @description: 点击左边分组，切换中间分组的展示内容
   * @param {*} index 点击的左侧分组的索引值
   * @return {*}
   */
  const clickLeftGroup = (index) => {
    setCurrentKey(index); // 左侧分组高亮切换
    setMiddleGroupList([tempTagList[index]]); // 切换中间分组展示的内容,因为左侧分组比中间分组多了一层 ‘全部’，所以索引要+1
  };
  /**
   * @description: 每次选择时统计一共选了多少个标签，相关的所有方法
   * @param {*}
   * @return {*}
   */
  let allSelectNum = 0; // 全局存一下一共选了几个标签
  const isArray = (obj) => { // 判断是否是数组类型
    return Object.prototype.toString.call(obj) === '[object Array]';
  };
  const numFun = (source) => {
    for (const i in source) {
      const item = source[i];
      if (isArray(item.crowdLabels) && !item.status) {//算到所选标签层为止
        numFun(item.crowdLabels);
      } else {
        allSelectNum += 1;
      }
    }
  };
  const getActiveListNum = useMemo(() => {
    allSelectNum = 0;
    numFun(activeTagList);
    return allSelectNum;
  }, [activeTagList]);

  useEffect(() => {
    setBreadcrumb();
    getTags();
  }, []);

  return (
    <div className={`${styles['tag-div']}`}>
      <div className={`${styles['form-box']}`}>
        <Form labelAlign='left' >
          <div style={{ justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <div className={`${styles['reactive-box']}`}>
              <div className={`${styles['auto-box']}`} style={{ marginRight: '40px' }}>
                <Form.Item >
                  <span style={{ color: '#fe5957' }}>*</span><span className={styles.mr15}>人群名称:</span>
                  <Input
                    name="人群名称"
                    size="small"
                    maxLength={32}
                    value={crowdInfo.name}
                    onChange={(val) => setCrowdInfo({ ...crowdInfo, name: val })}
                    style={{ width: '350px' }}
                  />
                </Form.Item>
              </div>
              <div className={`${styles['auto-box']}`}>
                <Form.Item >
                  <span className={styles.mr15}>人群描述:</span>
                  <Input
                    name="描述"
                    size="small"
                    maxLength={32}
                    value={crowdInfo.description}
                    onChange={(val) => setCrowdInfo({ ...crowdInfo, description: val })}
                    style={{ width: '350px' }}
                  />
                </Form.Item>
              </div>
              <div className={`${styles['auto-box1']}`}>
                <Form.Item
                  style={{
                    justifyContent: 'flex-end',
                    whiteSpace: 'nowrap',
                    textAlign: 'right',
                  }} >
                  <div >
                    <Button
                      type="primary"
                      className={`${styles.w88} ${styles.mr10}`}
                      onClick={createFun}
                    >保存人群
                    </Button>
                    <Button
                      type="normal"
                      className={`${styles.w88}`}
                      onClick={() => {
                        history.push('/CustomerManagement');
                      }}
                    >返回
                    </Button>
                  </div>
                </Form.Item>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div className={`${styles['back-box']} ${styles.mb20}`} >
        <div className={`${styles['calc-number']}`}>
          <div style={{ display: 'flex' }}>
            <div
              className="iconfont icon-chaojiyingxiaoicon_huaban1-02"
              style={{ fontSize: '46px', marginRight: '10px' }}
            />
            <div style={{ fontSize: '18px' }}>总人数：{crowdNum}人</div>
          </div>
          <Button
            type="normal"
            className={`${styles.w88}`}
            style={{ marginTop: '26px', color: '#5D4CFF' }}
            onClick={estimateFun}
          >人数计算
          </Button>
        </div>
      </div>
      <div className={`${styles['back-box']} ${styles['content-container']} ${styles['flex-between-center']}`}>

        <div className={`${styles['label-choose']} middle-div`}>
          <Tab>
            <Tab.Item title="云鹿标签" key="0">
              <div style={{ display: 'flex', width: '100%', height: '100%' }}>
                {/* 左侧分组结构 */}
                <div className={`${styles.category}`}>
                {
                    leftGroupList.map((item, index) => {
                      return (<div
                        key={`left_group_${index}`}
                        className={`${styles.ballon}`}
                        style={{
                          border: currentKey === index ? '1px solid #5D4CFF' : '1px solid #D7DDE4',
                          color: currentKey === index ? '#5D4CFF' : 'black',
                        }}
                        onClick={() => {
                          clickLeftGroup(index);
                        }}
                      >
                        {item.labelDescription}
                        ( {activeTagList.filter((item1)=>{return item1.labelDescription === item.labelDescription}).length > 0
                            ? activeTagList.filter((item1)=>{return item1.labelDescription === item.labelDescription})[0]?.crowdLabels[0]?.crowdLabels.length
                            : 0
                          }
                           /{item.crowdLabels[0].crowdLabels.length}
                        )
                      </div>);
                    })
                  }
                </div>

                {/* 中间分组结构 */}
                <div className={styles['fixed-height']}>
                  <div className={`${styles['label-container']}`}>
                    {
                      tempTagList.map((contItem, contIndex) => (<div key={`label_${contIndex}`}>
                        <> {contIndex === (currentKey) && returnHtml(contItem, contIndex)} </>
                      </div>))
                    }
                  </div>
                </div>

              </div>
            </Tab.Item>
          </Tab>
        </div>

        <div className={`${styles['group-method']}`}>
           <div className={`${styles.title}`}>
            <div>组合公式：组内所有标签为交集</div>
            <div style={{ fontSize: '12px', fontWeight: 500, display: 'flex' }}>
              <div>已选标签：</div>
              <div className={styles.red}>{getActiveListNum}</div>
              {/* <Button text type="primary" style={{marginLeft:"20px"}} onClick={()=>{labelClear()}}>清空</Button> */}
            </div>
          </div>
          {/* 右侧分组结构 */}
          <div className={`${styles['fixed-height']}`}>
            <TagMapping
              activeTagList={activeTagList}
              changeActiveTagValue={changeActiveTagValue}
              changeActiveList={createTag}
              pageType={match.params.type === 'create'? '1' : '2'} // '1'创建 '2'复制
            />
          </div>
        </div>
      </div>
      <Overlay
        visible={createSucc}
        align="cc cc"
        hasMask
        disableScroll
        canCloseByMask={false}
      >
        <span className="overlay-demo">
          创建人群成功，即将跳转人群管理页面
        </span>
      </Overlay>
      <Loading
        visible={isLoading}
        fullScreen
      />
    </div>
  );
};

export default CrowdTagYunLu;
